var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66406 4.7915C4.24782 4.7915 2.28906 6.75026 2.28906 9.1665V10.8664C2.28906 11.2116 2.00924 11.4914 1.66406 11.4914C1.31888 11.4914 1.03906 11.2116 1.03906 10.8664V9.1665C1.03906 6.0599 3.55746 3.5415 6.66406 3.5415H17.4974V4.7915H6.66406Z",
    fill: "#404349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.394 1.22456C15.6381 0.980484 16.0338 0.980484 16.2779 1.22456L18.4833 3.42993C18.89 3.83673 18.89 4.49628 18.4833 4.90307L16.2779 7.10845C16.0338 7.35252 15.6381 7.35252 15.394 7.10845C15.1499 6.86437 15.1499 6.46864 15.394 6.22456L17.4521 4.1665L15.394 2.10845C15.1499 1.86437 15.1499 1.46864 15.394 1.22456Z",
    fill: "#404349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 7.69189C18.6785 7.69189 18.9583 7.97172 18.9583 8.31689V10.0168C18.9583 13.1234 16.4399 15.6418 13.3333 15.6418H2.5V14.3918H13.3333C15.7496 14.3918 17.7083 12.4331 17.7083 10.0168V8.31689C17.7083 7.97172 17.9882 7.69189 18.3333 7.69189Z",
    fill: "#404349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60529 12.0581C4.84937 12.3021 4.84937 12.6979 4.60529 12.9419L2.54723 15L4.60529 17.0581C4.84937 17.3021 4.84937 17.6979 4.60529 17.9419C4.36121 18.186 3.96548 18.186 3.72141 17.9419L1.51603 15.7366C1.10924 15.3298 1.10924 14.6702 1.51603 14.2634L3.72141 12.0581C3.96548 11.814 4.36121 11.814 4.60529 12.0581Z",
    fill: "#404349"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoute);
export default __webpack_public_path__ + "static/media/route.b92a0b2bb9757b513804220fdc81ace2.svg";
export { ForwardRef as ReactComponent };